import React, { useContext, useState } from "react";
import DesktopNavigation from "./navigation/desktopNavigation";
import MobileNavigation from "./navigation/mobileNavigation";
import { Global } from "../context/globalContextProvider";
import useClientSide from "../hooks/useClientSide";

const Header = ({ isDonationHeader, campaignToDonationLink, campaignToDonationLinkMonthly, cosmosCampaignId }) => {
  const isClientSide = useClientSide();
  const globalContext = useContext(Global);
  const [menuSticky, setMenuSticky] = useState(true);
  const minScroll = 60;

  if (!isClientSide) {
    return null;
  }

  const urlParams = globalContext?.urlParams ?? "";


  const scrollBar = () => {
    if (typeof window !== "undefined") {
      let prevScrollpos = window.pageYOffset;
      window.onscroll = function (event) {
        const maxScroll = document.body.clientHeight - window.innerHeight;
        let currentScrollPos = window.pageYOffset;
        
        // If we're at the top of the page, make menu unsticky
        if (currentScrollPos <= 0) {
          if (menuSticky) setMenuSticky(false);
        }
        // If scrolling up and not at top, make menu sticky
        else if (prevScrollpos > currentScrollPos) {
          if (minScroll < currentScrollPos) setMenuSticky(true);
        }
        // If scrolling down, make menu sticky
        else if (prevScrollpos < currentScrollPos) {
          if (minScroll < currentScrollPos) setMenuSticky(true);
        }
        
        prevScrollpos = currentScrollPos;
      };
    }
  };

  scrollBar();

  return (
    <>
      <DesktopNavigation
        campaignToDonationLink={campaignToDonationLink}
        campaignToDonationLinkMonthly={campaignToDonationLinkMonthly}
        cosmosCampaignId={cosmosCampaignId}
        urlParams={urlParams}
        isDonationHeader={isDonationHeader}
        menuSticky={menuSticky}
      />
      <MobileNavigation
        campaignToDonationLink={campaignToDonationLink}
        campaignToDonationLinkMonthly={campaignToDonationLinkMonthly}
        cosmosCampaignId={cosmosCampaignId}
        urlParams={urlParams}
        isDonationHeader={isDonationHeader}
        menuSticky={menuSticky}
      />
    </>
  );
};

export default Header;
